import { useState } from "react";
import { motion } from "framer-motion";
import SectionHeading from "components/layout/SectionHeading";
import PdfModal from "components/common/PdfModal";
import { educationData } from "constants/education";

const Education = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);

  return (
    <>
      <section className="flex flex-col gap-12">
        <SectionHeading>Education</SectionHeading>

        {educationData.map((item, index) => (
          <motion.article
            key={`${item.title}-${item.date}`}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.02 }}
            className="flex flex-col md:flex-row items-center justify-center md:justify-between border border-black p-8 rounded-2xl shadow-md hover:shadow-slate-100 bg-slate-200 text-center md:text-left gap-6"
          >
            <div className="flex flex-col gap-4 text-center w-full md:w-auto">
              <span className="text-xl font-bold text-gray-800">{item.title}</span>
              <span className="text-lg text-gray-600">{item.school}</span>
              <span className="text-base text-gray-500">{item.date}</span>
            </div>

            {item.img && (
              <motion.img
                src={item.img}
                alt={item.title}
                onClick={() => setSelectedPdf(item.pdf)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-[20rem] h-50 bg-gray-300 rounded-xl cursor-pointer object-cover"
              />
            )}
          </motion.article>
        ))}
      </section>

      <PdfModal src={selectedPdf} onClose={() => setSelectedPdf(null)} />
    </>
  );
};

export default Education;
